import { Box } from "@mui/material";
import { IWikifolioWatchlistCtaData } from "src/api/server/wf-detail.types";
import { ArrowLink } from "src/components-mui/base/arrow-link/arrow-link";
import { Typography } from "src/components-mui/base/typography/typography";
import { WatchlistButton } from "src/components-mui/common/buttons/watchlist-button/watchlist-button";

interface IWatchlistCtaProps {
    wikifolioId: string;
    wikifolioShortDescription: string;
    isOnWatchlist: boolean;
    data: IWikifolioWatchlistCtaData;
}

export const WatchlistCta = ({
    wikifolioId,
    wikifolioShortDescription,
    isOnWatchlist,
    data: { headline, description, link },
}: IWatchlistCtaProps) => {
    return (
        <Box sx={{ alignItems: "center", py: [6, 6, 8] }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Typography
                    component="h2"
                    sx={{
                        fontSize: { xs: "3xl", sm: "3xl", md: "4xl" },
                        lineHeight: ["48px", "48px", "60px"],
                        fontWeight: ["bold", "bold", "heavy"],
                    }}
                >
                    {headline}
                </Typography>
                <Typography component="p" sx={{ fontSize: ["xl", "xl", "2xl"], maxWidth: ["none", "none", "626px", "670px"] }}>
                    {description}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: ["column", "row"], gap: 3, alignItems: ["initial", "center"] }}>
                    <WatchlistButton
                        size="medium"
                        wikifolioId={wikifolioId}
                        wikifolioShortDescription={wikifolioShortDescription}
                        isOnWatchlist={isOnWatchlist}
                    />
                    <ArrowLink href={link.url} target={link.target} sx={{ fontSize: "md", fontWeight: "semibold", textAlign: ["center", "initial"] }}>
                        {link.name}
                    </ArrowLink>
                </Box>
            </Box>
        </Box>
    );
};
